
import { FormsFeatureContext } from '@ngt/forms';
import { useCallback, useContext } from 'react';
import { KeyedMutator } from 'swr';
import { AttachmentDeleteSingleById, DeleteSingleResponse, IReturn, LotDeleteSingleById, StageDeleteSingleById, LotNoteDeleteSingleById, ReportDeleteSingleById, ReportTemplateDeleteSingleById, AssetDeleteSingleById } from '../../api/dtos';
import { DeleteTargetTypes } from '../../components/dialogs/DeleteDialog';

export const useDelete = (mutate?: KeyedMutator<DeleteSingleResponse>) => {
    const formsFeature = useContext(FormsFeatureContext);

    // @ts-ignore
    const deleteItem = useCallback(async (targetType?: DeleteTargetTypes, targetId?: number, metadata?: Record<string, any>) => {
        if(!targetType || !targetId) return false;

        let request;

        switch(targetType) {
            case DeleteTargetTypes.Stage:
                request = new StageDeleteSingleById({stageId: targetId});
                break;
            case DeleteTargetTypes.Lot:
                request = new LotDeleteSingleById({lotId: targetId});
                break;
            case DeleteTargetTypes.Attachment:
                request = new AttachmentDeleteSingleById({attachmentId: targetId});
                break;
            case DeleteTargetTypes.LotNote:
                request = new LotNoteDeleteSingleById({lotNoteId: targetId});
                break;
            case DeleteTargetTypes.Report:
                request = new ReportDeleteSingleById({reportId: targetId});
                break;
            case DeleteTargetTypes.ReportTemplate:
                request = new ReportTemplateDeleteSingleById({templateId: targetId});
                break;
            case DeleteTargetTypes.Asset:
                request = new AssetDeleteSingleById({assetId: targetId});
                break;
            default:
                break;
        }

        const response: DeleteSingleResponse = await formsFeature
            .serviceStackClient
            .delete(request as IReturn<DeleteSingleResponse>);

        return response;
    }, [formsFeature.serviceStackClient, mutate]);

    return deleteItem;
};

export default useDelete;